export default __webpack_public_path__ + "static/media/Water 1.d962b733.svg";